const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  // Caps raised for large monitors — a 1280px cap left ~40% of a 2560px screen
  // empty. Still capped rather than fluid so a table never stretches into an
  // unreadable measure. `headerInner` below takes the SAME cap classes, so the
  // top bar's controls land on the listing's own left and right edges.
  content: {
    ...theme.mainContent,
    maxWidth: "900px",
    width: "100%",
    margin: "0 auto",
    // Horizontal inset matches UserHeader's own 20px so the two line up.
    padding: "15px 20px",
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    background: "var(--cc-bg, #F6F5F2)",
    // Inset lives on headerInner instead, so both it and `content` centre
    // within the same available width.
    padding: 0,
    "@media print": {
      display: "none",
    },
  },
  // Mirrors `content`'s measure. UserHeader supplies its own 20px inset, which
  // is why `content` uses 20px horizontally too.
  headerInner: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
  },
  headerRedesign: {
    position: "sticky",
    top: 0,
    zIndex: 100,
    background: "#fff",
    margin: "0 -32px 16px",
    width: "calc(100% + 64px)",
    borderBottom: "1px solid #e3e1db",
    "@media print": {
      display: "none",
    },
  },
  contentLG: {
    maxWidth: "1760px",
  },
  contentMD: {
    maxWidth: "1400px",
  },
  contentFull: {
    maxWidth: "100%",
  },
  // Shell already applies .redesign-content-area padding.
  contentRedesign: {
    padding: 0,
  },
  // Opt-in full-bleed zen cream backdrop (matches the care-plan pages).
  // 56px = sticky UserHeader bar above the wrapper.
  contentZen: {
    background: "var(--cc-bg, #F6F5F2)",
    minHeight: "calc(100vh - 56px)",
  },
  // Redesign TopBar replaces UserHeader — don't reserve the old header strip.
  contentZenRedesign: {
    minHeight: "100%",
  },
  contentDashboard: {
    background: "var(--cc-bg, #F6F5F2)",
    minHeight: "100vh",
    position: "relative",
  },
}));
